import { FC, useContext } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import IResponse from '../../interfaces/response';
import { CampaignContext } from '../../contexts/CampaignContext';
import { useParams } from 'react-router-dom';

type ISortCampaignBox = {
	texts: { title: string; orderBy: string; orderByDirection: string }[];
};

const SortCampaignBox: FC<ISortCampaignBox> = ({ texts }) => {
	const { type } = useParams();
	const { typeActiveButton, selectedPlatformId, setSortPackages, setFetchedEntites, setFetchedEntitiesPagination, setFetchedPackages } = useContext(CampaignContext);
	const { t } = useTranslation();
	const handleSelect = (item: { title: string; orderBy: string; orderByDirection: string }) => {
		setSortPackages(item);
		axios<IResponse<any>>({
			method: 'get',
			url: typeActiveButton === 0 ? `/media_packages` : `/media_entities`,
			params: {
				campaign_type: type,
				media_id: selectedPlatformId?.toString(),
				order_by: item.orderBy,
				order_by_direction: item.orderByDirection,
			},
		}).then(res => {
			if (res.data.success) {
				if (typeActiveButton === 0) {
					setFetchedPackages(res.data.data);
				} else {
					setFetchedEntitiesPagination(res.data.pagination);
					setFetchedEntites(res.data.data);
				}
			}
		});
	};
	return (
		<Box className="flex flex-col items-center gap-y-5 rounded-lg">
			{texts.map((text, index) => (
				<Typography
					key={index}
					className="cursor-pointer px-4 py-2 text-sm font-normal text-text-secondary"
					onClick={() => handleSelect(text)} // <-- fix here
				>
					{t(text.title)}
				</Typography>
			))}
		</Box>
	);
};

export default SortCampaignBox;
